import { ColumnDef } from '@tanstack/react-table';
import React from 'react';
import Icons from '../../../../../../components/Common/Icons/Icons';
import { PdfViewerTrigger } from '../../../../../../context/pdfViewerDialog';

export interface UnreviewedDocsData {
  id: string;
  account: string;
  date: string;
  documentType: string;
  description: string;
  reviewed: boolean;
  filePath?: string;
}

export function DownloadDocLink({ href = '/guidance/sso_unviewed_document.pdf' }) {
  return (
    <PdfViewerTrigger src={href}>
      <a href="#" onClick={e => e.preventDefault()} aria-label="download-pdf">
        <Icons.PDF className="text-primary-text" />
      </a>
    </PdfViewerTrigger>
  );
}

const previousYear = new Date().getFullYear() - 1;

export const unreviewedDocsCol: ColumnDef<UnreviewedDocsData>[] = [
  {
    header: 'Account #',
    accessorKey: 'account',
    enableSorting: true,
    size: 200,
  },
  {
    header: 'Statement Date',
    accessorKey: 'date',
    size: 200,
    enableSorting: true,
  },
  {
    header: 'Document Type',
    accessorKey: 'documentType',
    enableSorting: true,
  },
  {
    header: 'Document Description',
    accessorKey: 'description',
    enableSorting: true,
  },
  {
    id: 'actions',
    accessorKey: '',
    header: 'View document',
    size: 160,
    cell: ({ row }) => (
      <div className="flex gap-4 items-center justify-end">
        {row.original.reviewed ? (
          <a
            href="/guidance/statements/unreviewed-document" // TODO add here modal to this html instead of page?
            aria-label="unreviewed-document"
            target="_blank"
            rel="noreferrer"
          >
            <Icons.Globe className="size-6" />
          </a>
        ) : null}
        <DownloadDocLink href={row.original.filePath || '/guidance/sso_unviewed_document.pdf'} />
      </div>
    ),
  },
];

export const unreviewedDocsData: UnreviewedDocsData[] = [
  {
    id: '1',
    account: '10098',
    date: `22 Mar, ${previousYear}`,
    documentType: 'eTax',
    description: '1099-INT',
    reviewed: false,
    filePath: '/guidance/pdfs/RISE-1098-Compliant.pdf',
  },
  {
    id: '2',
    account: '12345',
    date: `31 Mar, ${previousYear}`,
    documentType: 'Statements',
    description: 'Default statement',
    reviewed: true,
  },
  {
    id: '3',
    account: '21872',
    date: `23 Mar, ${previousYear}`,
    documentType: 'Loan Statement',
    description: 'Test Loan',
    reviewed: false,
  },
  {
    id: '4',
    account: '21873',
    date: `24 Mar, ${previousYear}`,
    documentType: 'Loan Statement',
    description: 'Loan',
    reviewed: false,
  },
];

export const unreviewedDocsDataAUser: UnreviewedDocsData[] = [
  {
    id: '1',
    account: '4560',
    date: `22 Mar, ${previousYear}`,
    documentType: 'eTax',
    description: '1099-INT',
    reviewed: false,
    filePath: '/guidance/pdfs/RISE-1098-Compliant.pdf',
  },
  {
    id: '2',
    account: '4564',
    date: `31 Mar, ${previousYear}`,
    documentType: 'Statements',
    description: 'Default statement',
    reviewed: true,
  },
  {
    id: '3',
    account: '4560',
    date: `22 Mar, ${previousYear}`,
    documentType: 'eTax',
    description: '1099-INT',
    reviewed: false,
    filePath: '/guidance/pdfs/RISE-1098-Compliant.pdf',
  },
  {
    id: '4',
    account: '4564',
    date: `31 Mar, ${previousYear}`,
    documentType: 'Statements',
    description: 'Default statement',
    reviewed: true,
  },
];

export const undeliverableEmailData: UnreviewedDocsData[] = [
  {
    id: '2',
    account: '64368',
    date: `26 Mar, ${previousYear}`,
    documentType: 'Statements',
    description: 'Test default',
    reviewed: true,
  },
  {
    id: '3',
    account: '124215',
    date: `29 Mar, ${previousYear}`,
    documentType: 'Loan Statement',
    description: 'Test Loan',
    reviewed: false,
  },
  {
    id: '1',
    account: '90098',
    date: `16 Mar, ${previousYear}`,
    documentType: 'eTax',
    description: '1099-INT',
    reviewed: false,
  },
];

export const undeliverableEmailAUser: UnreviewedDocsData[] = [
  {
    id: '1',
    account: '4560',
    date: `26 Mar, ${previousYear}`,
    documentType: 'Statements',
    description: 'Test default',
    reviewed: true,
  },
  {
    id: '2',
    account: '4564',
    date: `29 Mar, ${previousYear}`,
    documentType: 'Loan Statement',
    description: 'Test Loan',
    reviewed: false,
  },
  {
    id: '3',
    account: '4560',
    date: `26 Mar, ${previousYear}`,
    documentType: 'Statements',
    description: 'Test default',
    reviewed: true,
  },
  {
    id: '4',
    account: '4564',
    date: `29 Mar, ${previousYear}`,
    documentType: 'Loan Statement',
    description: 'Test Loan',
    reviewed: false,
  },
];
